import http from '@/utils/http';

/**
 * 海报管理
 */
export default {
  getList: {
    p: 'post,/manage/posters/getlist',
    r: (data) => http({ url: '/manage/posters/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/posters/add',
    r: (data) => http({ url: '/manage/posters/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/posters/update',
    r: (data) => http({ url: '/manage/posters/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/posters/delete',
    r: (data) => http({ url: '/manage/posters/delete', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/posters/getOne',
    r: (data) => http({ url: '/manage/posters/getOne', method: 'post', data })
  }
};
